export default __webpack_public_path__ + "static/beautydoc-logo-86c3f73e6673c871fa026bd046be13f5.png";